// extracted by mini-css-extract-plugin
export default {"wrapper":"GeometryIndicator__wrapper___1z4-9","icon":"GeometryIndicator__icon___5j_gD"};